import ReCAPTCHA from 'react-google-recaptcha';
import { forwardRef } from 'react';
import { useReCaptchaLoader } from '@/hooks/useReCaptchaLoader';

interface ReCaptchaProps {
  onVerify: (token: string | null) => void;
  onExpired?: () => void;
  onError?: () => void;
}

const RECAPTCHA_SITE_KEY = "6LcAwc0rAAAAAO4ljVrTaswvlFAn6VpNKW-wmflE";

export const ReCaptcha = forwardRef<ReCAPTCHA, ReCaptchaProps>(
  ({ onVerify, onExpired, onError }, ref) => {
    const { isLoaded, isLoading } = useReCaptchaLoader();

    const handleVerify = (token: string | null) => {
      onVerify(token);
    };

    const handleExpired = () => {
      if (onExpired) onExpired();
    };

    const handleError = () => {
      if (onError) onError();
    };

    if (!isLoaded) {
      return (
        <div className="flex justify-center my-4 h-[78px] items-center">
          {isLoading && <p className="text-sm text-muted-foreground">Loading verification...</p>}
        </div>
      );
    }

    return (
      <div className="flex justify-center my-4">
        <ReCAPTCHA
          ref={ref}
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={handleVerify}
          onExpired={handleExpired}
          onError={handleError}
          theme="light"
        />
      </div>
    );
  }
);

ReCaptcha.displayName = 'ReCaptcha';